import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FaCaretDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchGurdwaras, listGurudwaras } from "../../Data";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setGurdwaras } from "../../../../redux/slices/GurdwaraSlice";

const GurdwaraDropdown = () => {
  const [dropdownAds, setDropdownAds] = useState(false);
  const [selectedGurdwaras, setSelectedGurdwaras] = useState([]);
  const { gurdwaras } = useSelector((state) => state.gurdwara);
  // const [gurdwaras, setGurdwaras] = useState([]);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const toggle = () => setDropdownAds(!dropdownAds);

  const fetchData = async () => {
    try {
      const gurudwaras = await listGurudwaras();
      // setGurdwaras(gurudwaras);
      dispatch(setGurdwaras(gurudwaras));
    } catch (error) {
      console.error("Failed to fetch Gurdwaras:", error);
    }
  };

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      fetchData();
      hasFetched.current = true;
    }
  }, []);

  // Handle outside clicks to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownAds(false);
      }
    };

    if (dropdownAds) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownAds]);

  const handleGurudwaraSelect = (gurdwara) => {
    let updatedSelection;
    if (selectedGurdwaras.includes(gurdwara)) {
      updatedSelection = selectedGurdwaras.filter((item) => item !== gurdwara);
    } else {
      updatedSelection = [...selectedGurdwaras, gurdwara];
    }
    setSelectedGurdwaras(updatedSelection);
  };

  const handleApplySelection = () => {
    const formattedGurdwaras = selectedGurdwaras
      .map((g) => encodeURIComponent(g))
      .join(",");
    navigate(
      selectedGurdwaras.length > 0
        ? `/all-products?gurdwaras=${formattedGurdwaras}`
        : "/all-products"
    );
    setDropdownAds(false); // Close dropdown after applying
  };

  return (
    <div className="lca-latest-ads-dropdown p-0" ref={dropdownRef}>
      <Dropdown isOpen={dropdownAds} toggle={() => {}}>
        <DropdownToggle
          className="wd_filter-countaction lca-latest-dropdown inter-font "
          onClick={toggle}
          style={{ backgroundColor: "var(--white)" }}
        >
          Latest Ads{" "}
          {selectedGurdwaras.length > 0 ? `(${selectedGurdwaras.length})` : ""}
          <FaCaretDown />
        </DropdownToggle>
        <DropdownMenu
          className="wd_filter-countaction wd_filter-countaction-hover lca-latest-dropdown-menu inter-font"
          style={{ width: "200px", zIndex: 99, padding: "0px" }}
        >
          <DropdownItem
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "var(--button-bg)";
              e.target.style.color = "var(--white)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "initial";
              e.target.style.color = "black";
            }}
            onClick={() => {
              setSelectedGurdwaras([]); // Clear selections
              navigate("/all-products");
              setDropdownAds(false); // Close dropdown
            }}
            style={{
              // borderRadius: "0px 25px 0px 25px",
              borderBottom: "1px solid var(--theme-border)",
              fontSize: "14px",
              padding: "8px 10px 8px 20px",
            }}
          >
            View all Gurdwaras
          </DropdownItem>
          {gurdwaras.map((gurdwara) => (
            <DropdownItem
              key={gurdwara.Id}
              onClick={() => {
                handleGurudwaraSelect(gurdwara.Title);
              }}
              onMouseEnter={(e) => {
                if (!selectedGurdwaras.includes(gurdwara.Title)) {
                  e.target.style.backgroundColor = "var(--button-bg)";
                  e.target.style.color = "white";
                }
              }}
              onMouseLeave={(e) => {
                if (!selectedGurdwaras.includes(gurdwara.Title)) {
                  e.target.style.backgroundColor = "initial";
                  e.target.style.color = "black";
                }
              }}
              style={{
                borderBottom: "1px solid var(--theme-border)",
                fontSize: "14px",
                padding: "8px 10px 8px 20px",
                backgroundColor: selectedGurdwaras.includes(gurdwara.Title)
                  ? "var(--button-bg)"
                  : "initial",
                color: selectedGurdwaras.includes(gurdwara.Title)
                  ? "var(--letters)"
                  : "black",
              }}
              aria-selected={selectedGurdwaras.includes(gurdwara.Title)}
            >
              {gurdwara.Title}
            </DropdownItem>
          ))}
          {selectedGurdwaras.length > 0 && (
            <DropdownItem
              onClick={handleApplySelection}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#2b8044ff";
                e.target.style.color = "white";
              }}
              style={{
                fontSize: "14px",
                padding: "8px 10px 8px 20px",
                fontWeight: "bold",
                backgroundColor: "#70c088ff",
                color: "white",
              }}
            >
              Apply Selection
            </DropdownItem>
          )}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default GurdwaraDropdown;
